<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
 import {mapState, mapActions} from 'vuex';

 export default {
   name: 'app',
   methods: mapActions(['getPigs']),
   async created () {
     return this.getPigs();
   }
 }
</script>

<style>
 @import '~animate.css/animate.min.css';
 @import './styles/fonts.css'
</style>
